module.exports = __webpack_public_path__ + "static/img/6.2402af1b.png";